import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "account-pair-modal",
  "data-tour": "bb-test-pairs-dialog"
}
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "header-icon" }
const _hoisted_4 = { class: "header-text" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "pair-add-row" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "pair-error"
}
const _hoisted_9 = {
  key: 1,
  class: "pair-empty"
}
const _hoisted_10 = {
  key: 2,
  class: "pair-table-wrap"
}
const _hoisted_11 = { class: "pair-table" }
const _hoisted_12 = { class: "td-actions" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }

import { ref, watch } from 'vue';
import { bankbookApi } from '@/services/api';

interface AccountItem {
  scode: string;
  sname: string;
}

interface PairRow {
  cap_idx: number;
  income_sname: string;
  expense_sname: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountPairManageModal',
  props: {
    modelValue: { type: Boolean },
    year: {},
    incomeCodes: {},
    expenseCodes: {}
  },
  emits: ["update:modelValue", "changed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const saving = ref(false);
const pairs = ref<PairRow[]>([]);
const newIncome = ref<string | null>(null);
const newExpense = ref<string | null>(null);
const errorMessage = ref('');

const loadPairs = async () => {
  loading.value = true;
  errorMessage.value = '';
  try {
    const res = await bankbookApi.getAccountPairs(props.year);
    pairs.value = (res.data?.data || []) as PairRow[];
  } catch (err) {
    console.error(err);
    errorMessage.value = '허용 지출을 불러오지 못했습니다.';
  } finally {
    loading.value = false;
  }
};

const addPair = async () => {
  if (!newIncome.value || !newExpense.value) return;
  saving.value = true;
  errorMessage.value = '';
  try {
    await bankbookApi.createAccountPair({
      year: props.year,
      incomeScode: newIncome.value,
      expenseScode: newExpense.value,
    });
    newIncome.value = null;
    newExpense.value = null;
    await loadPairs();
    emit('changed');
  } catch (err: any) {
    errorMessage.value = err?.response?.data?.message || '연결을 추가하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const removePair = async (capIdx: number) => {
  if (!confirm('이 연결을 삭제할까요?')) return;
  errorMessage.value = '';
  try {
    await bankbookApi.deleteAccountPair(capIdx);
    await loadPairs();
    emit('changed');
  } catch (err: any) {
    errorMessage.value = err?.response?.data?.message || '연결을 삭제하지 못했습니다.';
  }
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) loadPairs();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "760",
    persistent: "",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "22",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-link-variant", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", null, "수입–지출 연결", -1)),
            _createElementVNode("p", null, _toDisplayString(__props.year) + "년 · 이 수입으로 나갈 수 있는 지출을 정해 둡니다. 지출 계정 추천에 표시됩니다.", 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "close-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_autocomplete, {
              modelValue: newIncome.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newIncome).value = $event)),
              items: __props.incomeCodes,
              "item-title": "sname",
              "item-value": "scode",
              label: "수입 계정",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              class: "pair-field"
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#94a3b8",
              class: "pair-arrow"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("mdi-arrow-right", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_autocomplete, {
              modelValue: newExpense.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newExpense).value = $event)),
              items: __props.expenseCodes,
              "item-title": "sname",
              "item-value": "scode",
              label: "지출 계정",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              class: "pair-field"
            }, null, 8, ["modelValue", "items"]),
            _createElementVNode("button", {
              type: "button",
              class: "pair-add-btn",
              disabled: saving.value || !newIncome.value || !newExpense.value,
              onClick: addPair
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-plus", -1)
                ]))]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" 추가 ", -1))
            ], 8, _hoisted_7)
          ]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "불러오는 중..."))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "수입 계정"),
                      _createElementVNode("th", null, "지출 계정"),
                      _createElementVNode("th", { class: "th-actions" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairs.value, (row) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.cap_idx
                      }, [
                        _createElementVNode("td", null, _toDisplayString(row.income_sname), 1),
                        _createElementVNode("td", null, _toDisplayString(row.expense_sname), 1),
                        _createElementVNode("td", _hoisted_12, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "pair-del-btn",
                            title: "삭제",
                            onClick: ($event: any) => (removePair(row.cap_idx))
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("mdi-delete-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_13)
                        ])
                      ]))
                    }), 128)),
                    (pairs.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("td", {
                            colspan: "3",
                            class: "empty-row"
                          }, "등록된 연결이 없습니다.", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})